import moment from 'moment';

export const hexToRGB = (hex: string, alpha: number) => {
  if (!hex) return '';
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);
  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
};

export const formatDate = (value: string | Date, format = 'DD/MM/YYYY') => {
  return value ? moment(value).format(format) : '';
};
export const transformResponse = () => {};
export const urlify = (text: string) => {
  const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
  const message = (text || '').replace(urlRegex, (url): any => {
    let hyperlink = url;
    if (!hyperlink.match('^https?://')) {
      hyperlink = 'http://' + hyperlink;
    }
    return `<a href="${hyperlink}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  return message;
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const parserTemplate = (templateScheme: string) => {
  return JSON.parse(`${templateScheme.replace(/'/g, '')}`);
};

export const uniqueItem = (data: any[], dataIndex: string) => {
  const collection = new Set();
  data.forEach((item) => {
    if (!collection.has(item[dataIndex])) {
      collection.add(item);
    }
  });
  return Array.from(collection);
};
export const compose = (...funcs) =>
  funcs.reduce(
    (a, b) =>
      (...args) =>
        a(b(...args)),
    (arg) => arg
  );

export * from './date';
